import {
    ServerSentEventTypes
} from 'actions/types';
import { logError } from 'utils/logError';

export function initServerSent(route) {
    return (dispatch, getState) => {
        dispatch({
            type: ServerSentEventTypes.INIT_SERVER_SENT_EVENT,
            payload: {
                route
            }
        })
        let eSource = new EventSource(route.get('href'));
        
        let locale = getState().security.get('locale').substring(0, 2);
        let sessionLink = `${getState().security.get('sessionId')}-${locale}`
        
        let streamUrl = route.get('href').split('?')[0];
        let connectionFailed = false;

        eSource.onopen = () => {
            connectionFailed = false;
            console.log("open");
        };

        eSource.onerror = (e) => {
            if (connectionFailed) return;
            connectionFailed = true;
            logError(`serverSentEvents: connect to ${streamUrl}`, e);
        };

        eSource.addEventListener(sessionLink, function(e) {
            
            let payload = {
                type: JSON.parse(e.data).type,
                message: JSON.parse(JSON.parse(e.data).payload),
                language: JSON.parse(e.data).language
            }

            if(payload.type !== 'ping') {
                dispatch({
                    type: ServerSentEventTypes.MESSAGE_SERVER_SENT_EVENT,
                    payload
                })
            }
        });
    }
}